export default "__VITE_ASSET__CN$EI3OZ__"